import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './Layout.css';

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    return (
        <div className="layout">
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
            <div className={`mobile-overlay${isSidebarOpen ? ' show' : ''}`} onClick={closeSidebar}></div>
            <div className={`main-content${isSidebarOpen ? ' sidebar-open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default Layout;
